import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../UserAccountLinker.module.scss";
import { MdCheckCircle } from "react-icons/md";

const SuccessLinked = ({ userName, senderOwner }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.statusCard}>
      <div className={styles.successIcon}><MdCheckCircle /></div>
      <p>
        {t("invite.success_linked_message", { owner: senderOwner })}
      </p>
      <p>
        {t("invite.success_activation_message")}
      </p>
    </div>
  );
};

export default SuccessLinked;
